import { useMutation } from "@tanstack/react-query";
import api from "@lib/api/axios";
import { MutationConfig } from "@lib/api/query";
import { apiEnum } from "@shared/types/enums/apiEnum";

type PayLoadType = {
    organizerEmail: string;
    resourceId: number;
};

const deleteFavorite = async (payload: PayLoadType) => {
    const { data } = await api.post(apiEnum.deleteFavorites, payload);
    return data;
};

type DeleteFavoriteType = {
    mutationConfig?: MutationConfig<typeof deleteFavorite>;
};

export const useDeleteFavorite = ({ mutationConfig }: DeleteFavoriteType) => {
    return useMutation({
        ...mutationConfig,
        mutationFn: deleteFavorite,
    });
};